import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  removeEntry(event) {
    const targetNode = event.currentTarget.closest('tr')
    if (!targetNode) { return }

    targetNode.classList.add('d-none')
  }
}
